type Axeptio = {
  openAxeptioCookieWidget: () => void;
};

declare global {
  interface Window {
    openAxeptioCookies?: () => void;
  }
}

export const useAxeptio = (): Axeptio => {
  const openAxeptioCookieWidget = () => {
    if (window.openAxeptioCookies != null) {
      window.openAxeptioCookies();
    }
  };

  return {
    openAxeptioCookieWidget,
  };
};
